/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function () {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

//スライダー
$(function () {
  $('.home-kv__slick').each(function (index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//フェード
$(function () {
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function (index, el) {
    var t = $(this);

    setTimeout(function () {
      $(window).on('resize scroll', function (event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if (h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if (sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if (d) {
        pointD = d;
      }

      if (pointH < pointSc) {
        setTimeout(function () {
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if (nextStr) {
        var nextArr = nextStr.split(' ');
        if (nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if (nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if (nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if (nextDelay) {
                step = delay;
              }
              if (nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function (index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function () {
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});
  
$(function(){
  $('.home-animal__imgs').each(function (index, element) {
    const $imgs = $(this);
    const $img = $('.home-animal__img');
    let num = 0;

    num = Math.floor(Math.random() * 10);

    $img.eq(num).addClass('is-on');
  });
});

//スライダー
$(function () {
  $('.home-topics__slider').each(function (index, el) {
    const $slider = $(this);
    let timer;

    $slider.on('init', function(event, slick){
      const $stop = $('.home-topics__slideStop');
      const $dots = $slider.find('.slick-dots');

      $dots.append($stop);
      $stop.show();

      $stop.on('click', function () {
        $stop.toggleClass('is-stop');

        if($stop.hasClass('is-stop')) {
          $slider.slick('slickPause');
        } else {
          $slider.slick('slickPlay');
        }
      });
    }).slick({
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 600,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: true,
      centerMode: true,
      variableWidth: true,
      infinite: false
    });

    timer = setInterval(function(){
      if($slider.hasClass('is-fade')) {
        clearInterval(timer);
        $slider.slick('slickPlay');
      }
    }, 100);

  });
});

$(function(){
  let isFirst = false;

  $(document).on('opening', '.remodal', function () {
    if(!isFirst) {
      isFirst = true;
      
      $(('.remodal-close')).each(function (index, element) {
        const $t = $(this);
        $t.prependTo($t.parent().parent());
      });
    }
  });
});

$(function () {
  $('.home-iroha__slider').each(function (index, el) {
    const $slider = $(this);

    $slider.slick({
      speed: 800,
      arrows: true,
      dots: false,
      variableWidth: true,
      centerMode: true
    });
  });
});

$(function () {
  $('.home-iroha__pulldown').each(function (index, el) {
    const $root = $(this);
    const $btn = $('.home-iroha__pulldownTtl');
    const $close = $('.home-iroha__pulldownClose');

    $btn.on('click', function () {
      const $t = $(this);
      const $con = $t.next();

      $t.toggleClass('is-on');
      $con.stop().slideToggle(300);
    });

    $close.on('click', function () {
      const $t = $(this);
      const $item = $t.parent().parent();
      const $ttl = $item.find('.home-iroha__pulldownTtl');
      const $con = $item.find('.home-iroha__pulldownCon');

      $ttl.toggleClass('is-on');
      $con.stop().slideToggle(300);

      let pos = $('.home-secu__inner').offset().top;
      $("html, body").animate({ scrollTop: pos }, 300, "swing");
    });
  });
});

$(function () {
  $('.home-animal__imgNav').each(function (index, el) {
    const $root = $(this);
    const $btn = $root.find('button');
    const $img = $('.home-animal__img');

    $btn.on('click', function () {
      const now = $btn.index(this);

      $img.removeClass('is-on');
      $img.eq(now).addClass('is-on');

      let pos = $('.home-animal__img').offset().top - 10;
      $("html, body").animate({ scrollTop: pos }, 300, "swing");
    });
  });
});